import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=1e1139a9&scoped=true"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"
import style0 from "./Feedback.vue?vue&type=style&index=0&id=1e1139a9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1139a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e1139a9')) {
      api.createRecord('1e1139a9', component.options)
    } else {
      api.reload('1e1139a9', component.options)
    }
    module.hot.accept("./Feedback.vue?vue&type=template&id=1e1139a9&scoped=true", function () {
      api.rerender('1e1139a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Feedback.vue"
export default component.exports